// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__16k9t","container":"styles_container__ZFo0s","title":"styles_title__1yxof","wrapper":"styles_wrapper__3H7iY","answer":"styles_answer__315hK"};